if (!customElements.get('pawce-scent-playground')) {
  customElements.define('pawce-scent-playground', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.cards = [...this.querySelectorAll('[data-scent-card]')];
      this.mobile = matchMedia('(max-width: 749px)');
      this.index = 0;
      this.dataset.enhanced = 'true';
      this.addEventListener('click', event => {
        if (Date.now() < this.suppressClickUntil) return;
        const direction = event.target.closest('[data-scent-direction]');
        if (direction) return this.move(Number(direction.dataset.scentDirection));
        const dot = event.target.closest('[data-scent-go]');
        if (dot) return this.select(this.cards[Number(dot.dataset.scentGo)]);
        const card = event.target.closest('[data-scent-card]');
        if (card) this.select(card);
      }, opts);
      this.addEventListener('keydown', event => {
        if (!event.target.closest('[data-scent-card]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : (this.index + (event.key === 'ArrowRight' ? 1 : -1) + this.cards.length) % this.cards.length;
        this.select(this.cards[index]);
        this.cards[index].focus({ preventScroll: true });
      }, opts);
      const track = this.querySelector('.pw-scents__track');
      track.addEventListener('pointerdown', event => {
        if (!this.mobile.matches || !event.isPrimary) return;
        this.gesture = { x: event.clientX, y: event.clientY };
      }, opts);
      track.addEventListener('pointerup', event => {
        if (!this.gesture) return;
        const dx = event.clientX - this.gesture.x, dy = event.clientY - this.gesture.y;
        this.gesture = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this.suppressClickUntil = Date.now() + 400;
          this.move(dx < 0 ? 1 : -1);
        }
      }, opts);
      track.addEventListener('pointercancel', () => { this.gesture = null; }, opts);
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-scent-card]');
        if (card && this.contains(card)) this.select(card);
      }, opts);
      this.mobile.addEventListener('change', () => this.update(), opts);
      this.select(this.cards[0]);
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.popTimer); }
    move(direction) { this.select(this.cards[(this.index + direction + this.cards.length) % this.cards.length]); }
    update() {
      this.cards.forEach((card, index) => {
        const selected = index === this.index;
        card.setAttribute('aria-pressed', String(selected));
        card.dataset.position = selected ? 'current' : index === (this.index + 1) % this.cards.length ? 'next' : 'previous';
        card.inert = this.mobile.matches && !selected;
      });
      this.querySelectorAll('[data-scent-go]').forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === this.index)));
    }
    select(card) {
      if (!card) return;
      this.index = this.cards.indexOf(card);
      this.update();
      this.style.setProperty('--scent-bg', card.dataset.scentColor);
      this.querySelector('[data-scent-name]').textContent = card.dataset.scentTitle;
      this.querySelector('[data-scent-description]').textContent = card.dataset.scentCopy;
      this.dataset.tapped = 'true';
      clearTimeout(this.popTimer);
      this.popTimer = setTimeout(() => { this.dataset.tapped = 'false'; }, 550);
    }
  });
}
